import { render, staticRenderFns } from "./lap_musrenbang_kecamatan.vue?vue&type=template&id=74e2b6fb&"
import script from "./lap_musrenbang_kecamatan.vue?vue&type=script&lang=js&"
export * from "./lap_musrenbang_kecamatan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports